
const spacesRegExp = /\s/g;

const functionRegExp = /(Min|RoundUp|RoundDown|SubtractingDates)/g;

const mathSymbolsRegExp = /\(([^)]+)\)|[+/\-*^,]/g;
const divisionRegExp = /\(/g;

function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export class functionParserService {
  static isAllSquareBracketsClosed(str) {
    let stack = [];

    for (let i = 0; i < str.length; i++) {
      if (str[i] === "[") {
        stack.push("[");
      }
      if (str[i] === "]") {
        if (stack.length === 0 || stack.pop() !== "[") {
          return false;
        }
      }
    }
    if (stack.length === 0) {
      return true;
    }

    return false;
  }

  static createFunctionValue(functionString, variablesForCondition) {
    if (!functionString) {
      return;
    }

    const functionStringWithoutSpace = functionString.replace(spacesRegExp, "");
  
    let currentExpressionString = functionStringWithoutSpace;
  
    const replacedValueObject = {};
  
    variablesForCondition.forEach((item) => {
      const currentReplaceString = item.label.replace(spacesRegExp, "");
      const regex = new RegExp(escapeRegExp(currentReplaceString), "g");
      const matches = (currentExpressionString.match(regex)?.length ?? 0);
  
      if (matches > 0) {
        replacedValueObject[currentReplaceString] = {
          matches,
          item,
        };
      }
    });

    const arraySortedVariables = Object.entries(replacedValueObject)
      .sort((item1, item2) => {
        const [, count1] = item1;
        const [, count2] = item2;
        if (count1.matches - count2.matches === 0) {
          return -1
        }
        return count1.matches - count2.matches;
      })
      .map((item) => item[1].item);

    
    arraySortedVariables.forEach((item) => {
      const currentReplaceString = item.label.replace(spacesRegExp, "");
  
      currentExpressionString = currentExpressionString.replaceAll(
        currentReplaceString,
        item.conditionKey.name
      );
    });
  
    currentExpressionString = currentExpressionString.replaceAll(/\[|\]/g, "");

    return currentExpressionString;
  }

  static parseStringToSearchValue(string) {
    if (!string) {
      return null;
    }

    //replace for division
    string = string?.replace(divisionRegExp, "");
    //function parse regExp
    string = string?.replace(functionRegExp, "");

    const stack = [];

    const wordStack = [];

    let currentString = null;

    //find value after squad brackets "["
    for (let index = 0; index < string.length; index++) {
      const character = string[index];
      if (character !== "]" && index !== 0) {
        if (character === "[") {
          stack.push(character);
        }
        wordStack.push(character);
        currentString = wordStack.join("");
      } else if (character === "[") {
        stack.push(character);
      } else {
        if (stack.length === 1) {
          currentString = null;
        } else {
          stack.pop();
          wordStack.push(character);
        }
      }
    }

    return currentString;
  }

  static getUnclosedVariableValue(string, cursorPoint) {
    const currentString = string?.slice(0, cursorPoint).replace(spacesRegExp, "");
    
    const parts = currentString.split(mathSymbolsRegExp).filter((string) => {
      if (!string) {
        return false;
      }
      return string?.trim() !== "";
    });
    const currentValue = parts.at(-1)?.trim();
    const result = this.parseStringToSearchValue(currentValue);

    return result;
  }

  static insertString({
    insertString,
    initialString,
    cursorIndex,
    replaceString,
    characterEndedString,
  }) {
    let newValue = initialString;

    let functionIndex = replaceString ? cursorIndex - 1 : cursorIndex;

    let replaceStringArray = replaceString ? replaceString?.split("") : ["["];

    for (let index = replaceStringArray.length - 1; index >= 0; index--) {
      if (index === 0) {
        const startValue = newValue?.slice(0, functionIndex) ?? "";
        const endValue = newValue?.slice(cursorIndex, newValue.length).trim() ?? "";
        newValue = startValue + insertString + characterEndedString + endValue;
      } else {
        functionIndex = functionIndex - 1;
      }
    }
    return newValue;
  }
}
